import React from 'react';
import { Button, Icon } from '@innovationnorway/cl-react';

import { useBoolean } from 'usehooks-ts';
import { useTranslation } from 'react-i18next';

import {
  DevelopmentProjectListItemDto,
  OperationProjectListItemDto,
  PortalProjectListItemDto,
} from 'src/api/v2';
type Props = {
  project: OperationProjectListItemDto | DevelopmentProjectListItemDto | PortalProjectListItemDto;
  createEventModal: ReturnType<typeof useBoolean>;
  registerInkindModal: ReturnType<typeof useBoolean>;
};
const ProjectCardButtons: React.FC<Props> = ({ project, createEventModal, registerInkindModal }) => {
  const { t: tEvents } = useTranslation('events');
  const { t: tSelfEffort } = useTranslation('selfEffort');
  if (project.projectEndReason) {
    return null;
  }
  return (
    <div className="display--flex flex-direction--column gap--2">
      <Button type="button" variant="secondary" onClick={createEventModal.setTrue}>
        <Icon prefix="fasr" iconName="clipboard-list" />
        {tEvents('newEvent')}
      </Button>

      <Button type="button" variant="secondary" onClick={registerInkindModal.setTrue}>
        <Icon prefix="fasr" iconName="sack-dollar" />
        {tSelfEffort('registerSelfEffort')}
      </Button>
    </div>
  );
};
export default ProjectCardButtons;
